"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./scss/style.scss");
const $ = require("jquery");
require("./js/__vendors/slick.min");
require("./ts/lib/layout/navigation");
require("./ts/template/newsletter");
require("./ts/services/recaptcha");
require("./ts/lib/layout/blog-list");
require("./ts/lib/layout/blog-list-footer");
require("./ts/themes/spring2024/components/carousels/tilesCarousel");
require("./ts/themes/spring2024/components/carousels/caseStudySlider");
require("./ts/themes/spring2024/components/carousels/sliderSectionCarousel");
require("./ts/themes/spring2024/components/carousels/contentSlider");
require("./ts/themes/spring2024/components/carousels/contentSliderShort");
require("./ts/themes/fall2024/components/carousels/growthSlider");
require("./ts/themes/fall2024/components/carousels/fullWidthCarousel");
require("./ts/themes/fall2024/components/carousels/testimonialsSlider");
require("./ts/themes/fall2024/components/members/members");
require("./ts/themes/fall2024/components/integrations/integrationsList");
require("./ts/themes/fall2024/components/gallery/gallery");
require("./ts/themes/fall2024/components/partners/partners");
require("./ts/themes/fall2024/components/collapse/collapse");
require("./ts/themes/fall2024/components/agenda/agenda");
$(document).ready(() => {
    function removeAriaHiddenFromSlides(slider) {
        slider.find('.slick-slide').each(function () {
            const $this = $(this);
            $this.attr('aria-hidden', 'false').removeAttr('tabindex');
            $this.find('[tabindex]').removeAttr('tabindex');
        });
    }
    $('[data-slick-container]').each(function () {
        const $slider = $(this);
        $slider.on('beforeChange', function () {
            removeAriaHiddenFromSlides($slider);
        });
    });
});
